import axios from "axios";

import { AirtableTableResponse } from "../types";

import { AIRTABLE_HEADERS, AIRTABLE_URL } from "@/constants/api";

/**
 * Returns all records in a Table from Airtable
 *
 * @remarks
 * API reference: https://airtable.com/developers/web/api/list-records
 *
 * @param tableId - string describing table ID from Airtable, also accepts table name
 * @returns Promise that resolves to the full airtable Table response
 *
 * @example
 * ```typescript
 * // Fetch by tableID (using AirtableTableId enum)
 * fetchAirtableTable(`${AirtableTableId.Collections}`);
 *
 * // Fetch by explicit tableID
 * fetchAirtableTable("tbl68wML9cjMrq9i7");
 * ```
 *
 * @throws Will throw an error if the network request fails
 */
const fetchAirtableTable = async (
  tableId: string,
): Promise<AirtableTableResponse> => {
  const url = `${AIRTABLE_URL}${tableId}`;

  return axios
    .get(url, { headers: AIRTABLE_HEADERS })
    .then((response) => {
      const data = response.data;
      return data;
    })
    .catch((error) => {
      console.error(`Error fetching Table ${tableId} from Airtable`, error);
    });
};

export { fetchAirtableTable };
